export default "__VITE_ASSET__l2GYhv0Q__"